// API
import Party from '@/axios/party'

// Parent lookups per tenant + set of store ids, kept for the session so
// re-selecting the same stores (or switching views) doesn't refetch.
const parentCache = new Map()

// Documents can be filed to a store's group rather than to the store itself
// (JBG files On-Hand reports to the store group). For tenants configured in
// the store's `storeParentPartyTypes`, a selected store also searches by its
// parents of those types. Expects the host component to have `selectedParties`
// and `handleError` (displayAlert).
export const partyParents = {
  data: () => ({
    selectedPartyParentIds: [],
    partyParentsSeq: 0
  }),
  computed: {
    storeParentTypes () {
      return this.$store.getters.storeParentPartyTypes[this.$auth.tenant] || []
    },
    selectedStoreIds () {
      const allRetailersId = this.$store.getters.allRetailersParty?.id
      return this.selectedParties.flatMap(party => {
        const id = party.party_id || party.id
        const type = party.party_type_constant || party.party_type
        return type === 'STORE' && id !== allRetailersId ? id : []
      })
    }
  },
  methods: {
    // Selected party ids plus the selected stores' parents, without duplicates.
    withPartyParents (partyIds) {
      return [...new Set([...partyIds, ...this.selectedPartyParentIds])]
    },
    // Resolves true once the parents for the current selection are in place,
    // false if a newer selection superseded this lookup.
    async loadSelectedPartyParents () {
      const seq = ++this.partyParentsSeq
      const storeIds = this.selectedStoreIds
      if (this.storeParentTypes.length === 0 || storeIds.length === 0) {
        this.selectedPartyParentIds = []
        return true
      }
      const key = `${this.$auth.tenant}:${[...storeIds].sort().join(',')}`
      let parentIds = parentCache.get(key)
      if (!parentIds) {
        try {
          const res = await Party.getUpstreamPartiesBatch(storeIds, this.storeParentTypes)
          parentIds = res?.data?.related || []
          parentCache.set(key, parentIds)
        } catch (err) {
          // still search by the selected parties themselves
          parentIds = []
          this.handleError(err)
        }
      }
      // a newer selection has started its own lookup
      if (seq !== this.partyParentsSeq) return false
      this.selectedPartyParentIds = parentIds
      return true
    }
  }
}
